import { useMemo } from 'react';

interface FormatOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  minimumIntegerDigits?: number;
}

export const useFormatCurrency = () => {
  const formatCurrency = useMemo(
    () =>
      (value: number | undefined, options: FormatOptions = {}) => {
        if (value !== undefined) {
          const formatted = new Intl.NumberFormat('en-ZA', {
            minimumFractionDigits: options.minimumFractionDigits ?? 2,
            maximumFractionDigits: options.maximumFractionDigits ?? 2
          }).format(value);
          return `R ${formatted.replace(/,/g, ' ')}`;
        }
      },
    []
  );

  const formatNumber = useMemo(
    () =>
      (value: number | undefined, options: FormatOptions = {}) => {
        if (value !== undefined) {
          const formatted = new Intl.NumberFormat('en-ZA', {
            minimumIntegerDigits: options.minimumIntegerDigits ?? 1
          }).format(value);
          return formatted.replace(/,/g, ' ');
        }
      },
    []
  );

  return { formatCurrency, formatNumber };
};
